import { alpha, ComponentsOverrides, ComponentsProps, ComponentsVariants, CssVarsTheme } from '@mui/material/styles';

export const MuiOutlinedInput: {
  defaultProps?: ComponentsProps['MuiOutlinedInput'];
  styleOverrides?: ComponentsOverrides<CssVarsTheme>['MuiOutlinedInput'];
  variants?: ComponentsVariants['MuiOutlinedInput'];
} = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: `${theme.spacing(0, 1.5)}!important`,
      background: alpha(theme.palette.hover.primary, 0.5),
      borderRadius: theme.spacing(1),
      '&:hover': {
        '& .MuiOutlinedInput-notchedOutline': {
          border: `1px solid ${theme.vars.palette.neutral['00']}`
        }
      },
      '&.Mui-focused': {
        boxShadow: `0 0 0 5px ${theme.palette.primary.light}30`,
        '& .MuiOutlinedInput-notchedOutline': {
          border: `1px solid ${theme.vars.palette.primary.main}`
        }
      },
      '&.Mui-error': {
        boxShadow: `0 0 0 4px ${theme.palette.error.light}20`,
        '& .MuiOutlinedInput-notchedOutline': {
          border: `1px solid ${theme.vars.palette.error.main}`
        }
      }
    }),
    input: ({ theme }) => ({
      padding: `${theme.spacing(1.875, 0)}!important`,
      fontSize: '0.875rem',
      lineHeight: '1.125rem',
      '&::placeholder': {
        color: theme.vars.palette.neutral.main
      }
    }),
    notchedOutline: ({ ownerState }) => ({
      top: 0,
      border: ownerState.error ? 'inherit' : 'none'
    }),
    sizeSmall: ({ theme }) => ({
      padding: `${theme.spacing(0, 1)}!important`,
      '& .MuiOutlinedInput-input': {
        padding: `${theme.spacing(1, 0)}!important`,
        fontSize: '0.75rem',
        lineHeight: '1.125rem'
      }
    })
  }
};

export const MuiInput: {
  defaultProps?: ComponentsProps['MuiInput'];
  styleOverrides?: ComponentsOverrides<CssVarsTheme>['MuiInput'];
  variants?: ComponentsVariants['MuiInput'];
} = {
  styleOverrides: {
    inputAdornedStart: ({ theme }) => ({
      margin: theme.spacing(1)
    }),
    inputAdornedEnd: ({ theme }) => ({
      marginX: theme.spacing(1)
    })
  }
};
